var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.id === 'profile')?_c('user-profile'):(_vm.id === 'preferences')?_c('user-preferences'):(_vm.id === 'password')?_c('user-password'):(_vm.id === 'audit-log')?_c('user-audit-log'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }